import {
  getProductionDataAction,
  updateProductionAction,
  createProductionAction,
  getCompaniesAction,
  getArtistNamesAction,
  createProductionCastAction,
  getVenuesAction,
  getLibrettistsNamesAction,
  createComposerAction,
  setProfessions,
  setRoles,
  getProductionCastAction,
  getProductionDatesAction,
  getArtistProductionDatesAction,
  getArtistsSuggestionsAction,
  getMediaAttributes,
  getFestivalsAction,
  getPerformanceCitiesAction,
  clearPerformanceCitiesAction,
  getPerformanceStagesAction,
  clearPerformanceStagesAction,
  updateProductionPerformancesAction,
  uploadSeveralMediaAction,
  getCompanyVenuesAction,
  getWorksAction,
  getProductionSinopsisAction,
  uploadProductionDocumentsAction,
  updateProductionSynopsisDocumentsAction,
  getProductionImagesAction,
  getProductionVideoAction,
  addProductionImageAction,
  addProductionVideoAction,
  getProductionLivestreamsAction,
  getComposersAction,
  getProductionVideoOnDemandAction,
  updateVideoOnDemandAction,
  getVideoCostTypesAction,
  getProductionVideoFormats,
  getProductionImageFormatsAction,
  createDigitalEventAction,
  deleteDigitalEventAction,
  updateLivestreamAction,
} from './actions';
import {
  defaultEntityParams,
  entityReducer,
  defaultListParams,
  listReducer,
  namedListParams,
} from '../../utils/crudUtils';
import {
  SET_PRODUCTION,
  CLEAN_OPTIONS_VALUES,
  SET_ADD_OPTION,
  CLEAR_PRODUCTION,
  DELETE_PRODUCTION_DOCUMENT,
  CLIENT_REMOVE_MEDIA,
  UPDATE_MEDIA,
} from './constants';
import { PERFORMANCE_TYPES_ID, PRODUCTION_DOCUMENT_TYPES } from '../../constants/consts';
import { changeItemInObjectsArray } from '../../utils/editCommon';

export const key = 'ProductionUpdate';

export const initialState = {
  production: defaultEntityParams,
  casts: defaultListParams,
  companies: defaultListParams,
  loadingFieldName: '', // Need it for field array requests
  professions: defaultListParams,
  roles: defaultListParams,
  names: defaultListParams,
  venues: defaultListParams,
  stages: defaultListParams,
  cities: defaultListParams,
  addOption: { name: null, composer: null, work: null, artist: null, previousPage: null, tempFormState: null },
  dates: defaultListParams,
  artistProductionDates: defaultListParams,
  artistsSuggestions: defaultListParams,
  images: defaultListParams,
  video: defaultListParams,
  mediaAttributes: defaultListParams,
  festivals: defaultListParams,
  companyVenues: defaultListParams,
  works: defaultListParams,
  documents: defaultListParams,
  booklets: [],
  livestreams: namedListParams('livestreams'),
  composers: defaultListParams,
  videoOnDemand: namedListParams('videoOnDemand'),
  videoCostTypes: namedListParams('videoCostTypes'),
  videoFormats: namedListParams('videoFormats'),
  imageFormats: namedListParams('imageFormats'),
};

const productionUpdateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getProductionDataAction.TRIGGER:
    case getProductionDataAction.SUCCESS:
    case getProductionDataAction.FAILURE:
    case updateProductionAction.TRIGGER:
    case updateProductionAction.SUCCESS:
    case updateProductionAction.FAILURE:
    case createProductionAction.TRIGGER:
    case createProductionAction.SUCCESS:
    case createProductionAction.FAILURE:
      return entityReducer(state, type, payload, 'production');

    case getCompaniesAction.TRIGGER:
    case getCompaniesAction.SUCCESS:
    case getCompaniesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'companies'), loadingFieldName: payload?.fieldName || '' };

    case SET_ADD_OPTION:
      return { ...state, addOption: { ...state.addOption, ...payload?.addOption } };

    case SET_PRODUCTION:
      return { ...state, production: { ...state.production, entity: payload?.production } };

    case CLEAN_OPTIONS_VALUES:
      return { ...state, [payload.field]: defaultListParams };

    case CLEAR_PRODUCTION:
      return {
        ...state,
        production: defaultEntityParams,
        casts: defaultListParams,
        companyVenues: defaultListParams,
        media: defaultListParams,
        artistProductionDates: defaultListParams,
      };

    case setProfessions.TRIGGER:
    case setProfessions.SUCCESS:
    case setProfessions.FAILURE:
      return listReducer(state, type, payload, 'professions');

    case setRoles.TRIGGER:
    case setRoles.SUCCESS:
    case setRoles.FAILURE:
      return listReducer(state, type, payload, 'roles');

    case getArtistNamesAction.TRIGGER:
      return { ...state, names: [], namesLoading: true };
    case getArtistNamesAction.SUCCESS:
    case getArtistNamesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'names'), namesLoading: false };

    case getLibrettistsNamesAction.TRIGGER:
      return { ...state, librettists: [], loadingFieldName: 'librettists' };
    case getLibrettistsNamesAction.SUCCESS:
      return { ...listReducer(state, type, payload, 'librettists'), loadingFieldName: '' };
    case getLibrettistsNamesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'librettists'), loadingFieldName: '' };

    case createProductionCastAction.TRIGGER:
      return { ...state, loadingFieldName: 'castCreating' };
    case createProductionCastAction.SUCCESS:
    case createProductionCastAction.FAILURE:
      return { ...state, loadingFieldName: '' };

    case getVenuesAction.TRIGGER:
    case getVenuesAction.SUCCESS:
    case getVenuesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'venues'), loadingFieldName: payload?.params?.fieldName || '' };

    case createComposerAction.TRIGGER:
    case createComposerAction.SUCCESS:
    case createComposerAction.FAILURE:
      return entityReducer(state, type, payload, 'composer');

    case getProductionCastAction.TRIGGER:
    case getProductionCastAction.SUCCESS:
    case getProductionCastAction.FAILURE:
      return listReducer(state, type, payload, 'casts');

    case getProductionDatesAction.TRIGGER:
    case getProductionDatesAction.SUCCESS:
    case getProductionDatesAction.FAILURE:
      return listReducer(state, type, payload, 'dates');

    case updateProductionPerformancesAction.TRIGGER:
      return { ...state, dates: { ...state.dates, loading: true } };
    case updateProductionPerformancesAction.FAILURE:
      return { ...state, dates: { ...state.dates, loading: false } };
    case updateProductionPerformancesAction.SUCCESS:
      return { ...state, dates: { ...state.dates, data: payload?.entity?.dates || [], loading: false } };

    case getArtistProductionDatesAction.TRIGGER:
    case getArtistProductionDatesAction.SUCCESS:
    case getArtistProductionDatesAction.FAILURE:
      return listReducer(state, type, payload, 'artistProductionDates');

    case getArtistsSuggestionsAction.TRIGGER:
    case getArtistsSuggestionsAction.SUCCESS:
    case getArtistsSuggestionsAction.FAILURE:
      return listReducer(state, type, payload, 'artistsSuggestions');

    case getProductionImagesAction.TRIGGER:
    case getProductionImagesAction.SUCCESS:
    case getProductionImagesAction.FAILURE:
      return listReducer(state, type, payload, 'images');

    case getProductionVideoAction.TRIGGER:
    case getProductionVideoAction.SUCCESS:
    case getProductionVideoAction.FAILURE:
      return listReducer(state, type, payload, 'video');

    case getMediaAttributes.TRIGGER:
    case getMediaAttributes.SUCCESS:
    case getMediaAttributes.FAILURE:
      return listReducer(state, type, payload, 'mediaAttributes');

    case getFestivalsAction.TRIGGER:
    case getFestivalsAction.SUCCESS:
    case getFestivalsAction.FAILURE:
      return { ...listReducer(state, type, payload, 'festivals'), loadingFieldName: payload?.fieldName };

    case addProductionImageAction.SUCCESS:
      return {
        ...state,
        images: { ...state.images, data: [...state.images.data, payload?.entity] },
        loadingFieldName: '',
      };
    case addProductionImageAction.TRIGGER:
    case addProductionImageAction.FAILURE:
      return { ...state, loadingFieldName: payload?.fieldName };

    case addProductionVideoAction.SUCCESS:
      return {
        ...state,
        video: { ...state.video, data: [...state.video.data, payload?.entity] },
        loadingFieldName: '',
      };
    case addProductionVideoAction.TRIGGER:
    case addProductionVideoAction.FAILURE:
      return { ...state, loadingFieldName: payload?.fieldName };

    case UPDATE_MEDIA: {
      const mediaTypeField = payload?.type === 'image' ? 'images' : 'video';
      return {
        ...state,
        [mediaTypeField]: {
          ...state[mediaTypeField],
          data: changeItemInObjectsArray(state[mediaTypeField]?.data, payload?.entity),
        },
      };
    }

    case CLIENT_REMOVE_MEDIA: {
      const mediaTypeField = payload?.type === 'image' ? 'images' : 'video';
      return {
        ...state,
        [mediaTypeField]: {
          ...state[mediaTypeField],
          data: state[mediaTypeField].data.filter(media => media?.id !== payload?.id),
        },
      };
    }
    case uploadSeveralMediaAction.TRIGGER:
      return { ...state, loadingFieldName: 'images' };
    case uploadSeveralMediaAction.SUCCESS:
      return { ...state, images: { ...state.images, data: [...state.images.data, ...payload] }, loadingFieldName: '' };
    case uploadSeveralMediaAction.FAILURE:
      return { ...state, loadingFieldName: '' };

    case getPerformanceCitiesAction.TRIGGER:
    case getPerformanceCitiesAction.SUCCESS:
    case getPerformanceCitiesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'cities'), loadingFieldName: payload?.fieldName };

    case clearPerformanceCitiesAction.TRIGGER:
      return { ...state, cities: defaultListParams };

    case getPerformanceStagesAction.TRIGGER:
    case getPerformanceStagesAction.SUCCESS:
    case getPerformanceStagesAction.FAILURE:
      return { ...listReducer(state, type, payload, 'stages'), loadingFieldName: payload?.fieldName };

    case getCompanyVenuesAction.TRIGGER:
    case getCompanyVenuesAction.SUCCESS:
    case getCompanyVenuesAction.FAILURE:
      return listReducer(state, type, payload, 'companyVenues');

    case getWorksAction.TRIGGER:
    case getWorksAction.SUCCESS:
    case getWorksAction.FAILURE:
      return { ...listReducer(state, type, payload, 'works'), loadingFieldName: payload?.fieldName || '' };

    case clearPerformanceStagesAction.TRIGGER:
      return { ...state, stages: defaultListParams };

    case getProductionSinopsisAction.TRIGGER:
    case getProductionSinopsisAction.FAILURE:
      return { ...listReducer(state, type, payload, 'documents'), booklets: [] };
    case getProductionSinopsisAction.SUCCESS: {
      const booklets = [];
      const other = [];
      const dataToSplit = [...payload?.data];
      dataToSplit.forEach(file => {
        if (file?.document_type === PRODUCTION_DOCUMENT_TYPES.BOOKLET) {
          booklets.push(file);
        } else {
          other.push(file);
        }
      });
      return { ...listReducer(state, type, { ...payload, data: other }, 'documents'), booklets };
    }
    case DELETE_PRODUCTION_DOCUMENT:
      return {
        ...state,
        booklets: state?.booklets?.filter(d => d?.id !== payload?.id),
      };

    case updateLivestreamAction.TRIGGER:
    case updateLivestreamAction.FAILURE:
      return { ...state, loadingFieldName: payload?.fieldName };
    case updateLivestreamAction.SUCCESS: {
      const livestreamsName = state.livestreams.listName;
      return {
        ...state,
        [livestreamsName]: {
          ...state[livestreamsName],
          data: changeItemInObjectsArray(state[livestreamsName]?.data, payload?.entity),
        },
        loadingFieldName: '',
      };
    }

    case uploadProductionDocumentsAction.TRIGGER:
      return { ...state, loadingFieldName: payload?.fieldName };
    case uploadProductionDocumentsAction.FAILURE:
      return { ...state, loadingFieldName: '' };
    case uploadProductionDocumentsAction.SUCCESS:
      return {
        ...state,
        booklets: [...state.booklets, ...payload],
        loadingFieldName: '',
      };

    case updateProductionSynopsisDocumentsAction.TRIGGER:
      return { ...state, loadingFieldName: payload?.fieldName };
    case updateProductionSynopsisDocumentsAction.SUCCESS:
    case updateProductionSynopsisDocumentsAction.FAILURE:
      return { ...state, loadingFieldName: '' };

    case getProductionLivestreamsAction.TRIGGER:
    case getProductionLivestreamsAction.SUCCESS:
    case getProductionLivestreamsAction.FAILURE:
      return listReducer(state, type, payload, 'livestreams');

    case getProductionVideoOnDemandAction.TRIGGER:
    case getProductionVideoOnDemandAction.SUCCESS:
    case getProductionVideoOnDemandAction.FAILURE:
      return listReducer(state, type, payload, state.videoOnDemand.listName);

    case updateVideoOnDemandAction.TRIGGER:
    case updateVideoOnDemandAction.FAILURE:
      return { ...state, loadingFieldName: payload?.fieldName };
    case updateVideoOnDemandAction.SUCCESS:
      return {
        ...state,
        [state.videoOnDemand.listName]: {
          ...state[state.videoOnDemand.listName],
          data: changeItemInObjectsArray(state[state.videoOnDemand.listName]?.data, payload?.entity),
        },
        loadingFieldName: '',
      };

    case getComposersAction.TRIGGER:
    case getComposersAction.SUCCESS:
    case getComposersAction.FAILURE:
      return { ...listReducer(state, type, payload, 'composers'), loadingFieldName: payload?.fieldName || '' };

    case getVideoCostTypesAction.TRIGGER:
    case getVideoCostTypesAction.SUCCESS:
    case getVideoCostTypesAction.FAILURE:
      return listReducer(state, type, payload, state.videoCostTypes.listName);

    case getProductionVideoFormats.FAILURE:
    case getProductionVideoFormats.TRIGGER:
    case getProductionVideoFormats.SUCCESS:
      return listReducer(state, type, payload, state.videoFormats.listName);

    case getProductionImageFormatsAction.FAILURE:
    case getProductionImageFormatsAction.TRIGGER:
    case getProductionImageFormatsAction.SUCCESS:
      return listReducer(state, type, payload, state.imageFormats.listName);

    case createDigitalEventAction.FAILURE:
    case createDigitalEventAction.TRIGGER:
    case deleteDigitalEventAction.FAILURE:
    case deleteDigitalEventAction.TRIGGER:
      return { ...state, loadingFieldName: payload?.fieldName };

    case createDigitalEventAction.SUCCESS: {
      const updatedStoreName =
        payload?.typeId === PERFORMANCE_TYPES_ID.VIDEO_ON_DEMAND
          ? state.videoOnDemand.listName
          : state.livestreams.listName;
      return {
        ...state,
        [updatedStoreName]: {
          ...state[updatedStoreName],
          data: [...state[updatedStoreName]?.data, payload?.entity],
        },
        loadingFieldName: '',
      };
    }

    case deleteDigitalEventAction.SUCCESS: {
      const updatedStoreName =
        payload?.typeId === PERFORMANCE_TYPES_ID.VIDEO_ON_DEMAND
          ? state.videoOnDemand.listName
          : state.livestreams.listName;
      return {
        ...state,
        [updatedStoreName]: {
          ...state[updatedStoreName],
          data: state[updatedStoreName]?.data?.filter(r => r?.id !== payload?.id),
        },
        loadingFieldName: '',
      };
    }
    default:
      return state;
  }
};

export default productionUpdateReducer;
